import React from 'react'
import { Checkbox } from '@/ui'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useBusinessTripChartViewStore } from '@/modules/drivers/stores/businessTripChartViewStore'

const FullChartViewToggle: React.FC = () => {
  const { t } = useLocalize()
  const showFullChart = useBusinessTripChartViewStore((s) => s.showFullChart)
  const setShowFullChart = useBusinessTripChartViewStore(
    (s) => s.setShowFullChart,
  )

  return (
    <label
      className="tw-ml-auto tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-text-sm tw-text-content-base"
      title={t('businessTrip.full-chart-view-hint')}
    >
      <Checkbox
        checked={showFullChart}
        onChange={(e) => setShowFullChart(e.target.checked)}
      />
      {t('businessTrip.full-chart-view')}
    </label>
  )
}

export default FullChartViewToggle
